<template>
  <div class="homepage">
    <Hero homepage />

    <Features />

    <section v-if="featuredShops" class="explore featured-shops grey-bg">
      <div class="container">
        <h2 class="left">Featured</h2>
        <div class="cards-grid">
          <r-grid columns="9" columns-s="1">
            <r-cell
              span="3"
              span-s="row"
              v-for="item in featuredShops"
              :key="item.Name"
            >
              <Card
                :class="`card-${item}`"
                :item="item"
                :showDistance="false"
              />
            </r-cell>
          </r-grid>
          <a @click="viewMoreFeatured" class="btn btn-outline explore-link">
            View all
            <i class="ml-8 fad fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>

    <section class="white-bg">
      <Benefits />
    </section>

    <section v-if="pastureForLifeShops" class="explore grassfed-100 grey-bg">
      <div class="container">
        <h2 class="left">Pasture For Life</h2>
        <div class="cards-grid">
          <r-grid columns="9" columns-s="1">
            <r-cell
              span="3"
              span-s="row"
              v-for="item in pastureForLifeShops"
              :key="item.Name"
            >
              <Card
                :class="`card-${item}`"
                :item="item"
                :showDistance="false"
              />
            </r-cell>
          </r-grid>
          <a
            @click="viewMorePastureForLifeShops"
            class="btn btn-outline explore-link"
          >
            View all
            <i class="ml-8 fad fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>

    <section class="white-bg">
      <Certifications />
    </section>

    <section class="grey-bg">
      <Faqs />
    </section>

    <SendMessage />
  </div>
</template>

<script>
import Hero from "../components/content/Hero";
import Features from "../components/content/Features";
import SendMessage from "../components/content/SendMessage";
import Benefits from "../components/content/Benefits";
import Certifications from "../components/content/Certifications";
import Faqs from "../components/content/Faqs";
import Card from "../components/content/Card";

// TODO: import these globally
//import config from "../src/config";
import airtable from "../src/airtable";

export default {
  name: "Home",
  metaInfo() {
    return {
      title: "Eat the best grass-fed meat",
    };
  },
  components: {
    Hero,
    Features,
    Benefits,
    Certifications,
    Faqs,
    SendMessage,
    Card,
  },
  data() {
    return {
      featuredShops: null,
      pastureForLifeShops: null,
    };
  },
  async mounted() {
    this.$gtag.pageview({ page_title: "Home", page_path: "/home" });

    const result =
      await airtable.getFeaturedAndPastureForLifeCertifiedShopsForHome();
    if (result !== null && result.length > 0) {
      this.shuffle(result);
      this.featuredShops = result.slice(0, 3);
    }

    if (result !== null && result.length > 0) {
      this.shuffle(result);
      this.pastureForLifeShops = result.slice(0, 3);
    }
  },
  methods: {
    trackEvent(action, category) {
      this.$gtag.event(action, {
        event_category: category,
      });
    },
    viewMoreFeatured() {
      this.trackEvent("click_filter_featured", "results");
      this.$router.push({ path: "results", query: { filters: "featured" } });
    },
    viewMorePastureForLifeShops() {
      this.trackEvent("click_filter_certification_pfla", "results");
      this.$router.push({
        path: "results",
        query: { filters: "pastureForLife" },
      });
    },
    shuffle(array) {
      // Durstenfeld shuffle (see http://en.wikipedia.org/wiki/Fisher%E2%80%93Yates_shuffle#The_modern_algorithm)
      var len = array.length - 1;
      for (let i = len; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.explore {
  text-align: center;
}
</style>
